import { studentModules } from "./studentModules";

// Talabaning ishlanmalar bo'yicha ishi (ish varag'i va o'z-o'zini baholash) shu qurilmada saqlanadi
const KEY = "mushtariy_modules";

export const loadProgress = () => {
    try {
        return JSON.parse(localStorage.getItem(KEY)) || {};
    } catch {
        return {};
    }
};

export const saveModuleProgress = (id, data) => {
    const all = loadProgress();
    all[id] = data;
    try {
        localStorage.setItem(KEY, JSON.stringify(all));
    } catch {
        // e'tiborsiz
    }
};

// 0 — boshlanmagan, 1 — jarayonda, 2 — bajarilgan
export const moduleStatus = (module, progress) => {
    if (!progress) return 0;
    const sheet = progress.worksheet || {};
    const rubric = progress.rubric || {};
    const filled = module.worksheet.filter((f) => (sheet[f.id] || "").trim()).length;
    const rated = Object.keys(rubric).length;
    if (filled === module.worksheet.length && rated === module.rubric.length) return 2;
    return filled || rated ? 1 : 0;
};

export const statusLabels = [
    { label: "Boshlanmagan", color: "#999" },
    { label: "Jarayonda", color: "#f59e0b" },
    { label: "Bajarilgan", color: "#10b981" },
];

export const completedCount = () => {
    const all = loadProgress();
    return studentModules.filter((m) => moduleStatus(m, all[m.id]) === 2).length;
};
